import { AlertTriangle } from 'lucide-react';
import { PhaseStubPage } from '@/components/layout/PhaseStubPage';

export function NcrCapaPage() {
  return (
    <PhaseStubPage
      title="NCR & CAPA"
      phase={5}
      modules={[
        'NCR intake from QC, customer complaints, or audit findings',
        '5-Why / fishbone root-cause aid',
        'Linked CAPA with effectiveness verification',
        'Trend dashboards by source / severity',
      ]}
      icon={AlertTriangle}
    />
  );
}
